/**
 * PURPOSE: The fatal-load-error guard chains, grouped by the action that makes each chain's input
 * available. A chain is ordered and the first match wins, so when two conditions hold at the same
 * time the earlier guard is the one whose message names the more specific cause.
 */

// libraries
import { offerSessionUtils } from '@makemydeal/dr-shared-ui-utils';
import { getAvailableDealerships, getIsEmployee } from '@makemydeal/dr-sales-checkin-store';

// consts/enums
import { MISSING_DEAL_XG_ID_MESSAGE, UNAUTHORIZED_DEALERSHIP_MESSAGE } from './applicationLoadErrorMessages';

// interfaces/types
import type { LoadErrorGuard } from '../types/applicationLoadError.types';

// utils
import { getUpstreamDealErrorMessage, isUpstreamDealError } from '../utils/applicationLoadErrorUtils';

/** Runs before the init request goes out, so these can only inspect the URL / session. */
export const PRE_REQUEST_GUARD_RULES: LoadErrorGuard[] = [
    {
        when: () => !offerSessionUtils.getDealXgId(),
        message: () => MISSING_DEAL_XG_ID_MESSAGE
    }
];

/** Runs once the init response has been reduced into state. */
export const POST_INIT_GUARD_RULES: LoadErrorGuard[] = [
    // Must stay ahead of the dealership guard: an envelope carries no `dealers`, so the dealership
    // slots come back empty and a missing deal would otherwise report as an access denial.
    {
        when: isUpstreamDealError,
        message: getUpstreamDealErrorMessage
    },
    {
        when: (state) => !getIsEmployee(state) && getAvailableDealerships(state).length === 0,
        message: () => UNAUTHORIZED_DEALERSHIP_MESSAGE
    }
];
